import ApiService, { HTTPMethod } from './api.core'

class StatesApi {
  async getStatesConfiguration() {
    return await ApiService.fetch('states/get_configuration', HTTPMethod.GET)
  }
}

export default new StatesApi()
